import React from 'react'
import ReactDOM from 'react-dom'
import './index.css'
import * as serviceWorker from './serviceWorker'
import { createBrowserHistory } from 'history'
import { applyMiddleware, compose, createStore } from 'redux'
import thunk from 'redux-thunk'
import { ConnectedRouter, routerMiddleware } from 'connected-react-router'
import { Provider } from 'react-intl-redux'
import './font/montserrat/montserrat.css'
import './font/blackerdisplay/blackerdisplay.css'
import LangProvider from './components/langContext/langContext'
import { setupOkta } from './utils/authClient'
import rootReducer from './modules/reducers'
import { CookiesProvider } from 'react-cookie'
import portals from './enums/portalsEnum'
import localStorageEnum from './enums/localStorageEnum'
import ThemeContext from './containers/ThemeContext'
import ReactGA from 'react-ga'
import { trackingEnum } from './modules/gtm/enum/trackingEnum'
import ResponsiveProvider from './utils/context/responsiveContext'
import AppProvider from './containers/context/AppContext'

interface OktaModel {
	acquisition_residence_uri: string,
	client_id: string,
	redirect_uri_renew_residence: string,
	redirect_uri_renew_campus: string,
	redirect_uri_renew: string,
	issuer: string,
	login_uri: string,
	cookie_domain: string,
	drupal: string
}

const reactInit = () => {
	// Create a history of your choosing (we're using a browser history in this case)
	const history = createBrowserHistory({
		basename: process.env.PUBLIC_URL
	})

	ReactGA.initialize(
		[
			{
				trackingId: trackingEnum.ecosystem.id,
				gaOptions: { name: trackingEnum.ecosystem.name }
			}
		]
	)

	// Initialisation de tous les enhancers utilisés avec Redux
	const enhancers = [
		applyMiddleware(
			thunk,
			routerMiddleware(history)
		)
	]

	// En mode dév, on utilise le devtools
	// @ts-ignore
	if (process.env.NODE_ENV !== 'production' && window.__REDUX_DEVTOOLS_EXTENSION__) {
		//@ts-ignore
		enhancers.push(window.__REDUX_DEVTOOLS_EXTENSION__())
	}

	// Création du store de redux
	let store = createStore(
		rootReducer,
		compose(...enhancers)
	)

	ReactDOM.render(
		<React.StrictMode>
			<Provider store={store}>
				<ConnectedRouter history={history}>
					<AppProvider>
						<LangProvider>
							<ResponsiveProvider>
								<CookiesProvider>
									<ThemeContext />
								</CookiesProvider>
							</ResponsiveProvider>
						</LangProvider>
					</AppProvider>
				</ConnectedRouter>
			</Provider>
		</React.StrictMode>,
		document.getElementById('root')
	)
}

const oktaConfig = () => {
	fetch('/api/conf/okta')
		.then(
			response => {
				if (response.ok) {
					response.json()
						.then(
							(data: OktaModel) => {
								const redirect_uri_renew: string = process.env.REACT_APP_TARGET === portals.residence ? data.redirect_uri_renew_residence : data.redirect_uri_renew_campus
								setupOkta(data.client_id, redirect_uri_renew, data.issuer)

								window.localStorage.setItem(localStorageEnum.commonUri,
									JSON.stringify(
										{
											acquisition_residence_uri: data.acquisition_residence_uri,
											login_uri: data.login_uri,
											cookie_domain: data.cookie_domain,
											drupal: data.drupal
										}
									)
								)

								reactInit()
							}
						)
				} else {
					setTimeout(
						() => {
							oktaConfig()
						}, 1000
					)
				}
			}
		)
		.catch(
			() => {
				setTimeout(
					() => {
						oktaConfig()
					}, 1000
				)
			}
		)
}

oktaConfig()

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()
